import loadable from '@loadable/component';

export const CinemablendSiteWrapper = loadable(
  () => import(/* webpackChunkName: "cinemablend-site" */ './CinemablendSiteWrapper'),
);
